import { NAQ_ROOT_CAUSES } from '@dispatch/shared/types';
import { ErrorOutline } from '@mui/icons-material';
import { Chip, Stack, Tooltip } from '@mui/material';

export type TaskNAQChipProps = {
  message: string;
  rootCauses?: string[];
};

const ROOT_CAUSE_LABELS: Record<string, string> = {
  [NAQ_ROOT_CAUSES.TimingGap]: 'Timing Gap',
  [NAQ_ROOT_CAUSES.PerilMismatch]: 'Peril Mismatch',
};

function labelForRootCause(cause: string): string {
  return ROOT_CAUSE_LABELS[cause] ?? cause;
}

export function TaskNAQChip({ message, rootCauses }: TaskNAQChipProps) {
  if (rootCauses && rootCauses.length > 0) {
    return (
      <Stack
        direction="row"
        gap={0.5}
        data-testid="task-NAQ-chip"
        flexWrap="wrap"
      >
        {rootCauses.map((cause) => (
          <Tooltip key={cause} title={message} placement="top">
            <Chip
              sx={{
                maxWidth: '10vw',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              color="warning"
              label={labelForRootCause(cause)}
              icon={<ErrorOutline />}
              data-testid={`task-NAQ-chip-cause-${cause}`}
            />
          </Tooltip>
        ))}
      </Stack>
    );
  }

  return (
    <Tooltip title={message} placement="top" data-testid="task-NAQ-chip">
      <Chip
        sx={{
          maxWidth: '10vw',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        color={'warning'}
        label={message}
        icon={<ErrorOutline />}
      />
    </Tooltip>
  );
}
